import React from 'react';
type PageHeaderProps = {
  title: React.ReactNode;
  lead?: React.ReactNode;
  image?: string;
  children?: React.ReactNode;
};
export function PageHeader({
  title,
  lead,
  image,
  children
}: PageHeaderProps) {
  return <header className="relative overflow-hidden border-b mf-hairline bg-deep" data-id="element-903" data-mp="krymazzw65rl">
      {image && <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" data-id="element-904" data-mp="ptfkgnqzre4h" />
          <div className="absolute inset-0 bg-deep/60" aria-hidden data-id="element-905" data-mp="tt66yf9hj837" />
        </>}
      <div className="relative mx-auto max-w-site px-5 pb-16 pt-20 md:px-8 md:pb-24 md:pt-28" data-id="element-906" data-mp="yr7zrrwpqlrv">
        <h1 className="max-w-4xl font-display text-5xl font-semibold uppercase leading-[0.95] tracking-[0.01em] text-white md:text-7xl" data-id="element-907" data-mp="13kkbj1gamy37">
          {title}
        </h1>
        {lead && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-titanium" data-id="element-908" data-mp="1di89e0974lpl">{lead}</p>}
        {children && <div className="mt-8" data-id="element-909" data-mp="1hi8zii5nqlch">{children}</div>}
      </div>
    </header>;
}